import { vservice } from '@niknevis/vue-modules'
import { BaseRequestLoadingHandler } from '@/modules/shared/interfaces/base-request-loading-handler.interface'
import { LatestNewsCollection } from '@/modules/news/models/news-collection.model'
import { AdminLatestNewsServices } from '@/modules/news/services/admin-news.service'

@vservice()
export class NewsEditUseCase implements BaseRequestLoadingHandler {
  constructor(
    private readonly service: AdminLatestNewsServices
  ) {
  }

  isSuccess = false
  isLoading = false

  execute(id: number, data: LatestNewsCollection) {
    return this.service.edit(id, data)
      .onStart(() => {
        this.isLoading = true
        this.isSuccess = false
      })
      .onFinish(() => {
        this.isLoading = false
      })
      .onSuccess(() => {
        this.isSuccess = true
      })
  }
}